import { BehaviorSubject } from 'rxjs';
import { PiezaBienCultural, PiezasResponse } from '../models/piezas-list.model';
import { PiezasBienCulturalInterface } from '../models/piezas-y-lotes.model';
import { ApiService } from './../../../../../../core/services/apiservice';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class PiezasBienCulturalService {
    piezasBienCultural:BehaviorSubject<PiezaBienCultural[]> = new BehaviorSubject<PiezaBienCultural[]>([]);

    get piezasBienCultural$() {
        return this.piezasBienCultural.asObservable();
    }

    constructor(private apiService: ApiService) { }
    

    postPiezasBienCultural(body:PiezasBienCulturalInterface){
        const url= `/pieza_bien_cultural` 
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body, {}, 'Error al Guardar Pieza.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    getPiezasBienCultural(uu_id:string){
        const url= `/pieza_bien_cultural/${uu_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener Piezas.')
                .subscribe((response:PiezasResponse) => {
                    this.piezasBienCultural.next(response.data);
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    deletePiezasBienCultural(uu_id_pieza:number){
        const url= `/pieza_bien_cultural/${uu_id_pieza}` 
        return new Promise((resolve, reject)=>{
            this.apiService.DeleteMethod(url, {}, 'Error al obtener Piezas.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }


    actualizarPiezasBienCultural(pieza:PiezasBienCulturalInterface){
        const url= `/pieza_bien_cultural` 
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, pieza, {}, 'Error al actualizar Piezas.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    
}